module.exports = __webpack_public_path__ + "static/media/ic_general_ship_black.92020e91.svg";